import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { applicationFieldsValidationFailed, applicationFieldsValidationSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* applicationFieldsValidation(action) {
  try {
    const {
      id,
      data,
    } = action.payload;
    const url = `${BACKEND_URL}/proxy/backend/api/v1/resources/applications/${id}/fields-validation`;
    const dataResponse = yield makeRequest(url, data, action, 'POST', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(applicationFieldsValidationSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(applicationFieldsValidationFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(applicationFieldsValidationFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
